export default __webpack_public_path__ + "static/media/confetti.6b1b1b24.svg";